
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("huub2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbbca583fb3fe9c1$var$_react = $cbbca583fb3fe9c1$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $cbbca583fb3fe9c1$var$_checkboxChecked = $cbbca583fb3fe9c1$var$_interopRequireDefault((parcelRequire("7FcUt")));
function $cbbca583fb3fe9c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cbbca583fb3fe9c1$var$CheckboxIcon = (props)=>/*#__PURE__*/ $cbbca583fb3fe9c1$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $cbbca583fb3fe9c1$var$_checkboxChecked.default
    }));
$cbbca583fb3fe9c1$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $cbbca583fb3fe9c1$var$_default = module.exports.default = $cbbca583fb3fe9c1$var$CheckboxIcon;

});


//# sourceMappingURL=checkbox.12ed1287.js.map
